import { Card, CardContent, CardHeader, Typography } from "@mui/material";
import { useEffect, useState, useCallback } from "react";
import { loadGlimpseOutput } from "../utils/dataLoader";

export const GlimpseErrorOutput = ({ caseId, clipId }) => {
  const [glimpseOutput, setGlimpseOutput] = useState("");

  const load = useCallback(async () => {
    const output = await loadGlimpseOutput(caseId, clipId);
    if (!output) {
      setGlimpseOutput("Error retrieving output");
    }
    setGlimpseOutput(output.value);
  }, [caseId, clipId]);

  useEffect(() => {
    load();
  }, [load]);

  return (
    <Card
      sx={{
        "&.MuiPaper-root": {
          display: "flex",
          flexDirection: "column",
          pb: 2,
          height: "calc(100vh - 340px)",
        },
        "& .MuiCardContent-root": {
          display: "flex",
          flex: 1,
          minHeight: 0,
          overflowY: "auto",
          overscrollBehavior: "contain",
        },
      }}
    >
      <CardHeader
        title="GLIMPSE Output"
        titleTypographyProps={{ fontSize: "1.25rem" }}
        sx={{ boxShadow: 2 }}
      />
      <CardContent>
        <Typography variant="body2" sx={{ whiteSpace: "pre-wrap" }}>
          {glimpseOutput}
        </Typography>
      </CardContent>
    </Card>
  );
};
